import { render, staticRenderFns } from "./room.vue?vue&type=template&id=9bb8536a&scoped=true&"
import script from "./room.vue?vue&type=script&lang=js&"
export * from "./room.vue?vue&type=script&lang=js&"
import style0 from "./room.css?vue&type=style&index=0&id=9bb8536a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb8536a",
  null
  
)

export default component.exports